module.exports = __webpack_public_path__ + "static/img/img1.90c6a92.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page_index/img1.png
// module id = /peF
// module chunks = 1